import {
  getLocale,
  overwriteGetLocale,
  setLocale,
  type Locale,
} from "$lib/paraglide/runtime";

/**
 * Locale helper. The locale is kept in a reactive `$state` and fed back into
 * Paraglide via `overwriteGetLocale()`, so switching needs no document reload
 * and must not remount the app chrome (that duplicated CS/EN switchers).
 */
let current = $state<Locale>(getLocale());
overwriteGetLocale(() => current);

export const i18n = {
  get locale(): Locale {
    return current;
  },

  setLocale(next: Locale) {
    if (next === current) return;
    current = next;
    setLocale(next, { reload: false });
  },
};
